import { useHasUnseenChangelogEntries } from "@-/dev.improve.haniverse.lib.changelog";
import { useMemo } from "react";

/**
 * Drawer rows that can carry a notification dot. Add a key here (and pass it to that row's
 * `DrawerAction`) to give another row a dot; the drawer trigger lights automatically.
 */
export interface NavAccountDrawerNotifications {
  changelog: boolean;
}

/**
 * Computed once in `NavAccountDrawer` rather than reported by the rows themselves: the trigger
 * must show the dot before the panel's contents have ever rendered.
 */
export function useNavAccountDrawerNotifications(): {
  hasNotifications: boolean;
  notifications: NavAccountDrawerNotifications;
} {
  const changelog = useHasUnseenChangelogEntries();

  return useMemo(() => {
    const notifications: NavAccountDrawerNotifications = { changelog };
    return {
      hasNotifications: Object.values(notifications).some(Boolean),
      notifications,
    };
  }, [changelog]);
}
